export const initialState = {
  deals: [],
};

const deals = (state = initialState, action) => {
  switch (action.type) {
    case 'LIST_DEALS':
      return {
        ...state,
        deals: action.data,
      };
    default:
      return state;
  }
};

export default deals;
